export default __webpack_public_path__ + "static/media/ExternalOrange.e5560eab.png";